module.exports = __webpack_public_path__ + "static/certik-f90fb07f4e9975ce12aeba7447a01a4f.svg";